import { render } from "./PngUploader.vue?vue&type=template&id=67d6f512&scoped=true"
import script from "./PngUploader.vue?vue&type=script&lang=js"
export * from "./PngUploader.vue?vue&type=script&lang=js"

import "./PngUploader.vue?vue&type=style&index=0&id=67d6f512&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d6f512"]])

export default __exports__